import { z } from 'zod'

export const RegistryUsage = z.object({
  config_id: z.number(),
  storage_quota_bytes: z.number(),
  free_tier_bytes: z.number(),
  free_egress_bytes: z.number(),
  storage_bytes: z.number(),
  egress_bytes: z.number(),
  pull_count: z.number(),
  push_count: z.number()
})
export type RegistryUsage = z.infer<typeof RegistryUsage>
